var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.items,"rules":_vm.rules,"label":_vm.$t('common.labels.country'),"disabled":_vm.disabled},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})}
var staticRenderFns = []

export { render, staticRenderFns }